import { isNil } from "ramda";

import ResponsiveImage from "components/ResponsiveImage";
import Placeholder from "components/Placeholder/Placeholder";
import MorphablePackGroupPresenter from "presenters/MorphablePackGroupPresenter";
import { useScreen } from "hooks";

const UpsellImage = ({ morphablePackGroup }) => {
  const { isMobile } = useScreen();
  const src = MorphablePackGroupPresenter.upsellImage(morphablePackGroup);
  const name = MorphablePackGroupPresenter.name(morphablePackGroup);

  return isNil(src) ? (
    <Placeholder variant="rectangular" width={isMobile ? 273 : 500} height={isMobile ? 348 : 637} />
  ) : (
    <ResponsiveImage src={src} alt={name} width={500} widthMobile={273} />
  );
};

UpsellImage.propTypes = {
  morphablePackGroup: MorphablePackGroupPresenter.shape(),
};

export default UpsellImage;
